import { useState } from "react";

export const useSearchFilters = () => {
  const MATCH_COUNT = 5;
  const ACTIVE_MODE = "summary";
  const [relevanceThreshold, setRelevanceThreshold] = useState(() =>
    Number(localStorage.getItem("relevanceThreshold") || 50)
  );
  const [daysAgo, setDaysAgo] = useState(-1);

  const handleRelevanceChange = (value: number) => {
    setRelevanceThreshold(value);
  };

  const handleDateRangeChange = (days: number) => {
    setDaysAgo(days);
    console.log("days", days);
  };

  return {
    relevanceThreshold,
    daysAgo,
    handleRelevanceChange,
    handleDateRangeChange,
    MATCH_COUNT,
    ACTIVE_MODE,
  };
};
